import { Avatar, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../image/boozLogo.png";
import { authResetState, loginRequest } from "../../redux/auth/AuthAction";
import CustomButton from "../constant/commonButton";
import {
  useFacebookSDK,
  useFacebookLogin,
  useGoogleLogin,
  useEmailLogin,
} from "../constant/facebookAndGoogleAuth";

import {
  StyledBox,
  StyledButton2,
  StyledContainer,
  styles,
} from "../components/LoginStyles";
import ReusableFormFields from "../constant/reusableFormFields";
import { APP_LINK } from "../global/MenuItems";
import { APP_LINKS } from "../global/wholeSalerMenuItems";
import { mapBackendMessage } from "../notification/BackendMessage";
import CommonDialog from "../notification/ErrorDialogbox";
import { LoginValue } from "../../redux/storeValues/StoreValuesAction";

const inputFields = [
  {
    // name: "emailOrcontact",
    name: "email",
    label: "Email Address",
    rules: {
      required: "Email is required",
      pattern: {
         value: /^(?:[^\s@]+@[^\s@]+\.[^\s@]+|\+?\d{7,15})$/,
      message: "Enter a valid email or mobile number",
      },
    },
  },
  {
    name: "password",
    label: "New Password",
    rules: {
      required: "New Password is required",
      pattern: {
        value: /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,12}$/,
        message: "Invalid password",
      },
    },
    type: "password",
  },
];
const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(true);
  const form = useForm();
  const { register, handleSubmit, formState, control } = form;
  const { errors } = formState;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const loginState = useSelector((state) => state?.auth?.user || {});
  const loginValue = loginState?.user;

  //Google Login Implements
  const googleLogin = useGoogleLogin();
  const emailLogin = useEmailLogin();

  //Facebook Login Implements
  useFacebookSDK();
  const loginWithFacebook = useFacebookLogin();

  const UserType = loginState?.user?.user_type;
  useEffect(() => {
    if (loginValue !== null) {
      dispatch(LoginValue(loginValue));
    }
  }, [loginValue, dispatch]);

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  // const handleForgotPassword = () => {
  //   navigate("/forgot-password");
  // };

  const handleSignin = () => {
    navigate(APP_LINK.REGISTER);
  };

  const handleLogin = (data) => {
    dispatch(loginRequest(data));
  };

  const handleLoginResponse = () => {
    if (loginState?.error) {
      const customMessage = mapBackendMessage(loginState?.errormessage);
      setDialogMessage(customMessage);
      setIsSuccess(false);
      setDialogOpen(true);
      dispatch(authResetState());
    } else if (loginState?.success) {
      if (loginState?.message) {
        setDialogMessage(
          loginState?.message ||
            "Please verify your account with the recent OTP received."
        );
        setIsSuccess(true);
      } else {
        if (UserType === "1") {
          navigate(APP_LINK.DASHBOARD);
        } else if (UserType === "3") {
          navigate(APP_LINKS.WHOLESALERDASHBOARD);
        } else {
          setDialogMessage(
            "Access Denied: You do not have permission to log in."
          );
          setIsSuccess(false);
          setDialogOpen(true);
          return;
        }
      }
      setDialogMessage("Login successful");
      setIsSuccess(true);
      setDialogOpen(true);
    }
  };

  useEffect(handleLoginResponse, [loginState, navigate]);

  return (
    <StyledBox>
      <StyledContainer
        maxWidth="xs"
        onSubmit={(e) => emailLogin(email, password, e)}
      >
        <form onSubmit={handleSubmit(handleLogin)}>
          <Grid container spacing={2} className="login-page">
            <Grid item xs={12} align="center">
              <Avatar src={Logo} className="avatar" />
            </Grid>
            <Grid item xs={12} align="center">
              <Typography
                variant="p"
                align="center"
                fontWeight={600}
                gutterBottom
              >
                Login Now
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <ReusableFormFields
                inputFields={inputFields}
                control={control}
                errors={errors}
                register={register}
              />
            </Grid>
            <Grid item xs={12}>
              <CustomButton
                text="Submit"
                size="large"
                type="submit"
                buttonStyle="StyledButton"
                disabled={loginState?.inProgress}
                loading={loginState?.inProgress}
              />
            </Grid>
            <Grid item xs={12} align="center">
              <Typography variant="body2" align="center" gutterBottom>
                <Link to="/forgot-password" style={styles.forgotPassword}>
                  Forgot Password?
                </Link>
              </Typography>
              <Typography variant="body2" align="center" gutterBottom>
                - - - - - - - - - or - - - - - - - - -
              </Typography>
            </Grid>
            <Grid item xs={12} align="center">
              <CustomButton
                text="Register"
                variant="contained"
                size="large"
                fullWidth
                buttonStyle="style1"
                onClick={handleSignin}
              >
                Wholesaler Register
              </CustomButton>
            </Grid>
            {/* <Grid item xs={12}>
              <Typography variant="body2" align="center" gutterBottom>
                - - - - - - - - - or - - - - - - - - -
              </Typography>
            </Grid> */}
            {/* <Grid item xs={12} align="center">
              <StyledButton2
                text="LOGIN WITH FACEBOOK"
                variant="contained"
                size="large"
                buttonStyle="style2"
                onClick={loginWithFacebook}
                fullWidth
              >
                LOGIN WITH FACEBOOK
              </StyledButton2>
            </Grid> */}
            {/* <Grid item xs={12} align="center">
              <CustomButton
                text="LOGIN WITH GOOGLE"
                variant="contained"
                size="large"
                buttonStyle="style1"
                onClick={googleLogin}
                fullWidth
              >
                LOGIN WITH GOOGLE
              </CustomButton>
            </Grid> */}
          </Grid>
        </form>
        <CommonDialog
          open={dialogOpen}
          isSuccess={isSuccess}
          onClose={handleDialogClose}
          messageSuccess={dialogMessage}
          messageError={dialogMessage}
        />
      </StyledContainer>
    </StyledBox>
  );
};

export default Login;
